import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

export const getTicketViewersById = (id, token) => {
  let url = `${baseUrl}/ticketViewers/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const createTicketViewersById = (id, data, token) => {
  return axios.post(`${baseUrl}/addTicketViewers/${id}`, data, {
    headers: {
      authorization: token,
    },
  });
};
export const deleteTicketViewersById = (ticketId, roleId, token) =>
  axios.delete(`${baseUrl}/deleteTicketViewers/${ticketId}/${roleId}`, {
    headers: {
      authorization: token,
    },
  });
export const getTicketViewersEmployees = (id, token) => {
  return axios.get(`${baseUrl}/getViewersEmployees/${id}`, {
    headers: {
      authorization: token,
    },
  });
};
export const getTicketViewersSubcustomers = (query, id, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/getViewersSubcustomers/${id}${qs}`, {
    headers: {
      authorization: token,
    },
  });
};
